import { useEffect } from "react";

export function useExitGuard(): void;
export function useExitGuard(enabled: boolean): void;
export function useExitGuard(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    addEventListener("beforeunload", (event) => void event.preventDefault(), {
      signal: controller.signal,
    });
    return () => {
      controller.abort();
    };
  }, [enabled]);
}
